import React from "react";
import QRCode from "react-qr-code";

interface QRModalProps {
  sessionId: string;
}

const QRModal: React.FC<QRModalProps> = ({ sessionId }) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ background: "#fff", padding: 20, borderRadius: 8 }}>
        <h2 className="text-lg font-semibold text-center mb-3">
          Scan QR to snap from phone
        </h2>

        {/* Instructions */}
        <p className="text-sm text-gray-600 mb-4">
          1. Open your phone's camera <br />
          2. Scan the QR code <br />
          3. Tap on the link
        </p>
        <QRCode value={sessionId} />
      </div>
    </div>
  );
};

export default QRModal;
